import type { SubNavigationProps } from './types';

import React from 'react';
import {
  SubNavigationNavBar,
  SmallSubNavigationNavBar,
} from './SubNavigationNavBar';
import { AltSubNavigationNavLink } from './AltSubNavigationNavItem';
import { SubNavigationNavLink } from './SubNavigationNavItem';
import {
  AltSubNavigationNavBar,
  AltSmallSubNavigationNavBar,
} from './AltSubNavigationNavBar';
import { useBillingPermissions } from 'ts-components/hooks/permissions/billing';

const SubNavigation = ({
  small = false,
  routes,
  id = 'subnavigation',
  params,
  currentSearch,
  ...props
}: SubNavigationProps) => {
  const SubNavBar = small ? SmallSubNavigationNavBar : SubNavigationNavBar;
  const billingPermissions = useBillingPermissions();

  return (
    <SubNavBar id={id} {...props}>
      {Object.entries(routes)
        .map(([key, route], index, arr) => {
          if (route.access?.hideFromNav) {
            return null;
          }

          if (
            typeof route.access?.checkBillingPermission === 'function' &&
            !route.access.checkBillingPermission(billingPermissions)
          ) {
            return null;
          }

          return (
            <React.Fragment key={index}>
              <SubNavigationNavLink
                numberOfLinks={arr.length}
                isLast={index === arr.length - 1}
                params={params}
                currentSearch={currentSearch}
                small={small}
                route={route}
                key={key}
              />
            </React.Fragment>
          );
        })
        .filter(Boolean)}
    </SubNavBar>
  );
};

export const AltSubNavigation = ({
  small = false,
  routes,
  id = 'subnavigation',
  params,
  ...props
}: Pick<SubNavigationProps, 'id' | 'params' | 'routes' | 'small'>) => {
  const SubNavBar = small
    ? AltSmallSubNavigationNavBar
    : AltSubNavigationNavBar;

  return (
    <SubNavBar className="alt" id={id} {...props}>
      {Object.entries(routes).map(([key, route], index, arr) => (
        <React.Fragment key={index}>
          <AltSubNavigationNavLink
            className={
              index === 0 && arr.length === 3 ? 'alt firstOfThree' : 'alt'
            }
            isLast={index === arr.length - 1}
            numberOfLinks={arr.length}
            key={key}
            route={route}
            small={small}
            params={params}
          />
        </React.Fragment>
      ))}
    </SubNavBar>
  );
};

export default SubNavigation;
